import { useState } from "react";
import { ChevronDown } from "lucide-react";

/* Admin "accordion" kart sarmalayıcısı.
 * Tüm admin bölümlerinde (Resend, Telegram, Google Takvim, reCAPTCHA, Google
 * Drive, Veri Aktarımı vs.) ortak kullanılır. Varsayılan olarak KAPALI gelir;
 * kullanıcı başlığa tıklayınca açılır.
 *
 * Props:
 *   title       : zorunlu, kartın başlığı
 *   description : opsiyonel kısa açıklama (başlığın altında stone-500)
 *   icon        : opsiyonel React node (lucide ikonu önerilir)
 *   chip        : opsiyonel sağda görünen "Bağlı / Bağlı değil" rozeti
 *   defaultOpen : opsiyonel, varsayılan false
 *   testid      : opsiyonel data-testid
 *   id          : opsiyonel DOM id (deep-link / anchor için)
 */
export default function CardCollapse({
  title,
  description,
  icon,
  chip,
  defaultOpen = false,
  testid,
  id,
  children,
}) {
  const [open, setOpen] = useState(!!defaultOpen);
  return (
    <div
      className="bg-white border rounded-xl overflow-hidden"
      data-testid={testid}
      id={id}
    >
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        className="w-full px-5 py-4 flex items-start justify-between gap-4 text-left hover:bg-stone-50/60 transition"
        data-testid={testid ? `${testid}-toggle` : undefined}
      >
        <div className="flex items-start gap-3 min-w-0 flex-1">
          {icon ? <span className="shrink-0 text-stone-700 mt-0.5">{icon}</span> : null}
          <div className="min-w-0">
            <h3 className="font-semibold text-base leading-snug">{title}</h3>
            {description ? (
              <p className="text-sm text-stone-500 mt-0.5 leading-snug">{description}</p>
            ) : null}
          </div>
        </div>
        <div className="flex items-center gap-2 shrink-0 pt-0.5">
          {chip}
          <ChevronDown
            size={18}
            className={`text-stone-400 transition-transform ${open ? "rotate-180" : ""}`}
          />
        </div>
      </button>
      {open ? (
        <div className="px-5 pb-5 pt-5 space-y-5 border-t border-stone-100">
          {children}
        </div>
      ) : null}
    </div>
  );
}
